export const CalculatePointEstimate = (data: number[]) => {
	let value = 0;
	let x: number[] = [];
	let y: number[] = [];
	data.forEach((tuple: number) => {
		if (tuple[0] || tuple[1]) {
			x.push(tuple[0]);
			y.push(tuple[1]);
			if (tuple[1] > value) {
				value = tuple[1];
			}
		}
	});
	return value;
}